const {
  REACT_APP_API_URL_DEV,
  REACT_APP_API_URL_V2,
  // REACT_APP_API_URL_V1,
  REACT_APP_X_APP_ID,
  REACT_APP_X_APP_API_KEY
  // eslint-disable-next-line no-undef
} = process.env;

const host_v2 = REACT_APP_API_URL_V2;
const host_v1 = REACT_APP_API_URL_DEV;

export const urls = {
  url: host_v2,
  user: host_v2 + '/system',
  service: host_v2 + '/service/support',
  notification: host_v2 + '/service/feature/notification',
  resource: host_v2 + '/service/resource/vehicles',
  token: host_v2 + '/token',
  auth: host_v2 + '/auth',
  account: host_v2 + '/account',
  project: host_v2 + '/projects/car-all-right/user'
};

// 소금광산 문자인증 헤더
export const saltmineSMSHeader = (smsVerifyToken) => {
  return {
    'Content-Type': 'application/json',
    'x-app-id': REACT_APP_X_APP_ID,
    'x-app-api-key': REACT_APP_X_APP_API_KEY,
    'x-verification-token': smsVerifyToken
  };
};

// 소금광산 일반 헤더
export const saltmineJsonHeader = () => {
  return {
    'Content-Type': 'application/json',
    'x-app-id': REACT_APP_X_APP_ID,
    'x-app-api-key': REACT_APP_X_APP_API_KEY
  };
};

// 소금광산 전용 api jwt 헤더
export const saltmineJwtHeaders = (token) => {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
    'x-app-id': REACT_APP_X_APP_ID,
    'x-app-api-key': REACT_APP_X_APP_API_KEY
  };
};

// 파일 업로드 헤더
export const saltmineFormDataHeadersNonToken = () => {
  return {
    'Content-Type': 'multipart/form-data',
    'x-app-id': REACT_APP_X_APP_ID,
    'x-app-api-key': REACT_APP_X_APP_API_KEY
  };
};

// 파일 업로드 헤더
export const saltmineFormDataHeaders = (token) => {
  return {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${token}`,
    'x-app-id': REACT_APP_X_APP_ID,
    'x-app-api-key': REACT_APP_X_APP_API_KEY
  };
};

// 파일 업로드 헤더
export const formDataHeaders = (token) => {
  return {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${token}`
  };
};

// 일반 헤더
export const jsonHeader = () => {
  return {
    'Content-Type': 'application/json'
  };
};

// jwt 헤더
export const headers = (token) => {
  return {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`
  };
};

// 객체 정리
export const cleanObject = (object = {}) => {
  const cleanElements = [null, undefined, 'null', 'undefined', ''];
  const cleanObject = { ...object };

  // 문자열 좌우 공백 제거
  Object.keys(cleanObject).forEach((key) => {
    if (typeof cleanObject[key] === 'string') {
      cleanObject[key] = cleanObject[key].trim();
    }
  });

  // 불필요 속성 제거(ex, null, undefined)
  const propNames = Object.getOwnPropertyNames(cleanObject);
  for (let i = 0; i < propNames.length; i++) {
    const propName = propNames[i];
    if (cleanElements.includes(cleanObject[propName])) {
      delete cleanObject[propName];
    }
  }

  return cleanObject;
};

// 파일 업로드 폼데이터 변환
// export const objectToFormData = (object) => {
//   const formData = new FormData();

//   for (let key in object) {
//     console.log('object[key]', object[key]);
//     formData.append(key, object[key]);
//   }

//   return formData;
// };

export const objectToFormData = (object) => {
  const formData = new FormData();

  for (let key in object) {
    // attachments 필드에 배열이 포함된 경우 배열의 각 파일을 append
    if (Array.isArray(object[key]) && key === 'attachments') {
      object[key].forEach((file) => {
        formData.append(key, file); // 파일을 attachments[] 형태로 추가
      });
    } else {
      formData.append(key, object[key]);
    }
  }

  return formData;
};
